import React, { useState, useEffect } from 'react'
import styled from 'styled-components'

import ResponsiveContainer from 'components/utils/ResponsiveContainer'


const Schedule = ({ scheduleData, title, hideRoomName }) => {
    scheduleData.sort( (a,b) => parseInt((new Date(a.date).getTime() / 1000).toFixed(0)) - parseInt((new Date(b.date).getTime() / 1000).toFixed(0)) )

    const [currentPageId, setCurrentPageId] = useState(scheduleData[0].id)
    const [displayedSchedule, setDisplayedSchedule] = useState(...scheduleData.filter( item => item.id === currentPageId))

    useEffect(() => {
        setDisplayedSchedule(...scheduleData.filter( item => item.id === currentPageId))
    }, [scheduleData,currentPageId,setCurrentPageId])

    const PageButton = ({children, pageId}) => {
        return <button onClick={ () => setCurrentPageId(pageId)} className={`px-8 py-2 border-2 border-white border-solid mb-4 mx-2 font-bold md:mb-0 ${ pageId === currentPageId ? 'bg-white text-black' : ''}`}>{ children }</button>
    }

    return (
        <section>
            <ResponsiveContainer className="py-16">
                <div className="border-b border-solid border-white pb-4 mb-8">
                    <div className="text-center mb-4 md:mb-0 md:text-left">
                        <h6 className="text-optician-sans uppercase text-2xl">{ title }</h6>
                    </div>
                </div>
                <div className="flex justify-center flex-wrap border-b border-solid border-white pb-8 mb-8">
                    { scheduleData.map( item => {
                        const date = new Date(item.date)
                        return <PageButton pageId={item.id} key={item.id}>{`${date.getDate()} ${date.toLocaleString('default', { month: 'short' })}`}</PageButton>
                    }) }
                </div>
                <div>
                    { displayedSchedule && displayedSchedule.chanels.map( item => {
                        item.schedule.sort( (a,b) => {
                            const aStr = a.Start.split(':')
                            const bStr = b.Start.split(':')
                            return `${aStr[0]}${aStr[1]}` - `${bStr[0]}${bStr[1]}`
                        })
                        return (
                            <div className="mb-12">
                                { !hideRoomName && <h6 className="text-optician-sans uppercase text-4xl mb-8">{ item.roomName }</h6> }
                                <ScheduleColumn className="">
                                    { item.schedule.map( item => {
                                        const startTimeArr = item.Start.split(":")
                                        const speakersArr = item.Speakers.sort( (a,b) => a.Order - b.Order ).map( item => <p className="mb-0">{`${ item.Name }`}{ item.Title.trim().length > 0 && <>, <em className="text-xs">{ item.Title }</em></>}</p> )
                                        return (
                                            <div className="flex mb-4 " key={startTimeArr.join()}>
                                                <div className="flex-0 mr-6">
                                                    <div className="bg-gray-700 w-20 py-4 flex items-center justify-center">{startTimeArr[0]}:{startTimeArr[1]}</div>
                                                </div>
                                                <div>
                                                    <h5 className="uppercase text-optician-sans mb-2 text-2xl">{ item.Title }</h5>
                                                    { item.Speakers.length > 0 &&
                                                        speakersArr.map( item => item )
                                                    }
                                                    { item.Note && <div className="mt-4 text-xs font-italic">{ item.Note }</div> }
                                                </div>
                                            </div>
                                        )
                                    }) }
                                </ScheduleColumn>
                            </div>
                        )
                    }) }
                </div>
            </ResponsiveContainer>
        </section>
    )
}

const ScheduleColumn = styled.div`
    @media (min-width: 1024px) {
        column-count: 2;
        column-gap: 3rem;
        & > * {
            break-inside: avoid;
        }
    }
`

export default Schedule
